import { render, staticRenderFns } from "./CustomerInfoTabs.vue?vue&type=template&id=1bcca184&scoped=true"
import script from "./CustomerInfoTabs.vue?vue&type=script&lang=js"
export * from "./CustomerInfoTabs.vue?vue&type=script&lang=js"
import style0 from "./CustomerInfoTabs.vue?vue&type=style&index=0&id=1bcca184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcca184",
  null
  
)

export default component.exports